// 生成手机二维码
import QRCode from 'qrcodejs2'
export default (div, qrCodeId, mobileVideoToken, language, isExam, width, height, colorDark, colorLight, timeType) => {
  let url = window.location.origin
  if (url.indexOf('top') > -1 || url.indexOf('localhost') > -1) {
    url = `https://www.webloom.top/bloom_h5/#/Proctor?examId=`
  } else {
    url = `https://www.webloom.cn/bloom_h5/#/Proctor?examId=`
  }
  let qrcode = new QRCode(div, {
    text: url + qrCodeId + '&timeType=' + timeType + '&mobileVideoToken=' + mobileVideoToken + '&language=' + language + '&isExam=' + 2, // 需要转换为二维码的内容
    width,
    height,
    colorDark,
    colorLight,
    correctLevel: QRCode.CorrectLevel.H
  })
  return qrcode
}



// WEBPACK FOOTER //
// ./src/components/bloom-proctor/public/createQrCode.js